import BaseModel from '../core/BaseModel'

export default class WarrantyRepairDetailModel extends BaseModel {
    constructor() {
        super({
                name: "warranty_repair_detail",
                tableName: 'core_warranty_repair'
            },
            {
                id: {
                    name: 'id',
                    type: "String",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },
                code: {
                    name: 'code',
                    type: "String",
                    label: 'Mã dịch vụ',
                    width: 15,
                    sortable: false,
                    filter: {type: 'input', match: 'custom', placeHolder: 'Nhập mã DV'}
                },
                receive_user_info: {
                    name: 'receive_user_info',
                    type: "String",
                    label: 'Khách hàng',
                    sortable: true,
                    width: 15,
                    filter: { type: 'input',  match: 'custom'},
                    computed: (data) => {
                        var receive_user_info = "";
                        if (data.obj_receive_user){
                            receive_user_info = (data.obj_receive_user.customer_profile) ? data.obj_receive_user.customer_profile.full_name:'';
                        }
                        data.receive_user_info = receive_user_info;
                    }
                },
                list_serial_number_info: {
                    name: 'list_serial_number_info',
                    type: "String",
                    label: 'Serial number',
                    sortable: true,
                    width: 15,
                    filter: { type: 'input',  match: 'custom'},
                    computed: (data) => {
                        var list_serial_number = (data.list_serial_number) ? data.list_serial_number.trim():"";
                        var str_serial = list_serial_number;//bỏ ký tự đầu và cuối
                        str_serial = str_serial.replaceAll('#', '');
                        str_serial = str_serial.replaceAll(',', '<br>');
                        data.list_serial_number_info = str_serial;
                    }
                },
                receive_day_reception: {
                    name: 'receive_day_reception',
                    type: "Date",
                    label: 'Ngày tiếp nhận',
                    width: 15,
                    sortable: true,
                    filter: { type: 'DateRange', match: 'custom'}
                },
                delivery_return_appointment_day: {
                    name: 'delivery_return_appointment_day',
                    type: "Date",
                    label: 'Ngày hẹn trả',
                    width: 15,
                    sortable: true,
                    filter: { type: 'DateRange', match: 'custom'}
                },
                organization_creator_info: {
                    name: 'organization_creator_info',
                    type: "String",
                    label: 'Đơn vị thực hiện',
                    sortable: true,
                    width: 15,
                    filter: { type: 'input',  match: 'custom'},
                    computed: (data) => {
                        var organization_creator_info = "";
                        if (data.obj_creator){
                            if (data.obj_creator.organization_account){
                                if (data.obj_creator.organization_account.organization){
                                    organization_creator_info = (data.obj_creator.organization_account.organization.name) ? data.obj_creator.organization_account.organization.name:'';
                                }
                            }
                        }
                        data.organization_creator_info = organization_creator_info;
                    }
                },
                creator_info: {
                    name: 'creator_info',
                    type: "String",
                    label: 'Người tạo',
                    sortable: true,
                    width: 15,
                    filter: { type: 'input',  match: 'custom'},
                    computed: (data) => {
                        var creator_info = "";
                        if (data.obj_creator){
                            creator_info = (data.obj_creator.full_name) ? data.obj_creator.full_name:'';
                        }
                        data.creator_info = creator_info;
                    }
                },
                process_status: {
                    name: 'process_status',
                    label: 'Tiến độ thực hiện',
                    type: "Selection",
                    dataType: 'Label',
                    class: 'center disabled-opacity',
                    width: 15,
                    disabled: true,
                    options: [{ value: 0, label: 'Gửi yêu cầu', style: 'color: #CC0000; font-weight: 500;'}, { value: 1, label: 'Chờ tiếp nhận', style: 'color: #990099; font-weight: 500;'}, { value: 2, label: 'Chờ thực hiện', style: 'color: #0066FF; font-weight: 500;'}, { value: 3, label: 'Chờ giao trả', style: 'color: #FF6600;font-weight: 500;'}, { value: 4, label: 'Hoàn thành', style: 'color: #009900;font-weight: 500;'}],
                    filter: {type: 'select', display: false, optionLabel: 'label', optionKey: 'value', match: 'equals'},
                },
                fied_detail: {
                    refs: 'note_delivery receive_organization_id created_date receive_contact_info delivery_user_id receive_user_id delivery_organization_id list_serial_number receive_sender receive_method receive_note delivery_relative_receiving delivery_method delivery_apartment_number total_cost  obj_receive_user  {full_name phone_number obj_customer_profile { id full_name phone_number } organization_account { organization { name id } } } obj_creator { id full_name organization_account { organization { name id } } } obj_modifier { id full_name organization_account { organization { name id } } }  obj_receive_organization { id name } obj_delivery_organization { id name } obj_delivery_user {full_name phone_number obj_customer_profile { id full_name phone_number } organization_account { organization { name id } }} province{ id name } district{ id name } ward{ id name } arr_warranty_repair_product_serial_number{ id process_status type_service check_maintenance_period } arr_warranty_repair_product_serial_number_aggregate(where: { status: {_eq: "1"},_or:[{check_result: {_eq: 0}},{_and: [{check_result: {_eq: 2}},{check_is_customer_reply: {_eq: 1}}]}]}) { aggregate { sum { service_total_price_payment } } } obj_creator_organization{ name id } ',
                    display: false
                },
            },)
    }
}